export default __webpack_public_path__ + "static/media/xspeedcache-enterprise.870b9f8e.svg";